<template>
  <div>
    <p class="mb-1">
      <span v-if="primaryBadge" :class="primaryBadge.className">
        {{ primaryBadge.text }}
      </span>
    </p>
    <p class="mb-1">
      <span v-if="secondaryBadge" :class="secondaryBadge.className">
        <b-spinner v-if="secondaryBadge.showActionNeededIndicator" type="grow" small></b-spinner>
        {{ secondaryBadge.text }}
      </span>
    </p>

    <p v-if="benhNhan.requestCommunityCareSeniorDoctorUser">
      <b>Người nhận đề nghị: </b>
      <button-link-user :user="benhNhan.requestCommunityCareSeniorDoctorUser" />
    </p>
  </div>
</template>

<script>
import {EMERGENCY_STATE, getEmergencyState} from '../utils/emergencyUtils';
import ButtonLinkUser from '../../../components/ButtonLinkUser.vue';

export default {
  components: {
    ButtonLinkUser,
  },
  props: {
    benhNhan: {
      type: Object,
      required: true,
      validator: benhNhan => !!benhNhan._id,
    },
  },
  computed: {
    emergencyState() {
      return getEmergencyState(this.benhNhan);
    },
    primaryBadge() {
      switch (this.emergencyState) {
        case EMERGENCY_STATE.NORMAL:
        case EMERGENCY_STATE.NORMAL__EMERGENCY_REQUESTED:
        case EMERGENCY_STATE.NORMAL__EMERGENCY_REJECTED:
          return {
            className: 'badge badge-secondary',
            text: 'Chăm sóc thông thường',
          };
        case EMERGENCY_STATE.EMERGENCY:
        case EMERGENCY_STATE.EMERGENCY__COMMUNITY_CARE_REQUESTED:
          return {
            className: 'badge badge-warning',
            text: 'Cấp cứu',
          };
        case EMERGENCY_STATE.COMMUNITY_CARE:
        case EMERGENCY_STATE.COMMUNITY_CARE__EMERGENCY_REQUESTED:
        case EMERGENCY_STATE.COMMUNITY_CARE__EMERGENCY_REJECTED:
          return {
            className: 'badge badge-info',
            text: 'Chăm sóc cộng đồng',
          };
        case EMERGENCY_STATE.UNFOLLOWED:
          return {
            className: 'badge badge-light',
            text: 'Đã ngừng theo dõi',
          };
        default:
          return {
            className: 'badge badge-dark',
            text: `${this.emergencyState}`,
          };
      }
    },

    secondaryBadge() {
      switch (this.emergencyState) {
        case EMERGENCY_STATE.NORMAL:
        case EMERGENCY_STATE.COMMUNITY_CARE:
        case EMERGENCY_STATE.EMERGENCY:
        case EMERGENCY_STATE.UNFOLLOWED:
          return null;
        case EMERGENCY_STATE.NORMAL__EMERGENCY_REQUESTED:
        case EMERGENCY_STATE.COMMUNITY_CARE__EMERGENCY_REQUESTED:
          return {
            className: 'badge badge-danger',
            text: 'Đề nghị cấp cứu',
            showActionNeededIndicator: true,
          };
        case EMERGENCY_STATE.NORMAL__EMERGENCY_REJECTED:
        case EMERGENCY_STATE.COMMUNITY_CARE__EMERGENCY_REJECTED:
          return {
            className: 'badge badge-info',
            text: 'Đề nghị cấp cứu bị từ chối',
          };
        case EMERGENCY_STATE.EMERGENCY__COMMUNITY_CARE_REQUESTED:
          return {
            className: 'badge badge-warning',
            text: 'Đề nghị chăm sóc cộng đồng',
            showActionNeededIndicator: true,
          };
        default:
          return null;
      }
    },
  },
};
</script>
